import { render, staticRenderFns } from "./modal-termos-pendentes.vue?vue&type=template&id=64562686"
import script from "./modal-termos-pendentes.vue?vue&type=script&lang=js"
export * from "./modal-termos-pendentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports